(function () {

  class SmartHeader {
    
    constructor(el) {
      this.el = el;
      this.lastY = 0;
      this.lockReveal = false;
      this.bounds = { top: 0, bottom: 0 };

      this.container = document.getElementById('shopify-section-header');
      this.mode = this.el.dataset.stickyType;

      this.alwaysStick = ['always', 'reduce-logo-size'].includes(this.mode);

      this.searchBox = this.el.querySelector('predictive-search');

      this.handleScroll = this.handleScroll.bind(this);
      this.blockReveal = () => (this.lockReveal = true);

      this.el.addEventListener('preventHeaderReveal', this.blockReveal);
      window.addEventListener('scroll', this.handleScroll, { passive: true });

      if (this.alwaysStick) {
        this.container.classList.add('is-fixed');
      }

      this.initObserver();
    }

    initObserver() {
      const io = new IntersectionObserver((entries) => {
        const rect = entries[0].intersectionRect;
        this.bounds = rect;
        io.disconnect();
      });

      io.observe(this.container);
    }

    handleScroll() {
      const y = window.scrollY || document.documentElement.scrollTop;

      if (this.searchBox?.isOpen) return;

      const scrollingDown = y > this.lastY;
      const passedHeader = y > this.bounds.bottom;

      if (scrollingDown && passedHeader) {
        this.applyScrolledState();
        this.swapLogo('sticky');
        if (!this.alwaysStick) this.hideHeader();
      } 
      else if (!scrollingDown && passedHeader) {
        this.applyScrolledState();

        if (!this.lockReveal) {
          this.showHeader();
        } else {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => {
            this.lockReveal = false;
          }, 80);

          this.hideHeader();
        }
      } 
      else if (y <= this.bounds.top) {
        this.resetHeader();
        this.swapLogo('default');
      }

      this.lastY = y;
    }

    /* ---------- STATES ---------- */
    applyScrolledState() {
      this.container.classList.add('is-scrolled');
    }

    resetHeader() {
      if (this.alwaysStick) return;

      this.container.classList.remove('is-scrolled', 'is-hidden', 'is-visible', 'with-anim');
    }

    hideHeader() {
      if (this.alwaysStick) return;

      this.container.classList.add('is-hidden', 'is-fixed');
      this.container.classList.remove('is-visible');
      this.cleanupUI();
    }

    showHeader() {
      if (this.alwaysStick) return;

      this.container.classList.add('is-fixed', 'is-visible', 'with-anim');
      this.container.classList.remove('is-hidden');
    }

    /* ---------- HELPERS ---------- */
    swapLogo(type) {
      const show = type === 'sticky';

      document.querySelectorAll('.logo_static_header').forEach(el => {
        el.classList.toggle('d-none', show);
        el.classList.toggle('d-block', !show);
      });

      document.querySelectorAll('.logo_sticky_header').forEach(el => {
        el.classList.toggle('d-block', show);
        el.classList.toggle('d-none', !show);
      });
    }

    cleanupUI() {
      this.closeMenus();
      this.closeSearch();
    }

    closeMenus() {
      this.menus = this.menus || this.container.querySelectorAll('header-menu');
      this.menus.forEach(menu => menu.close());
    }

    closeSearch() {
      this.searchModal =
        this.searchModal ||
        this.container.querySelector('details-modal') ||
        this.container.querySelector('details');

      if (!this.searchModal) return;

      if (typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      } else {
        this.searchModal.open = false;
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const headerEl = document.getElementById('smart-header');
    if (headerEl) new SmartHeader(headerEl);

    /* ===== STICKY OFFSET LOGIC ===== */
    const header = document.getElementById('shopify-section-header');

    function setHeaderHeight() {
      if (!header) return;

      document.documentElement.style.setProperty(
        '--header-height',
        `${header.offsetHeight}px`
      );
    }

    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight);
  });

  document.addEventListener('shopify:section:load', () => {
    const header = document.getElementById('shopify-section-header');
    if (!header) return;

    document.documentElement.style.setProperty(
      '--header-height',
      `${header.offsetHeight}px`
    );
  });

  // INIT
  document.addEventListener('DOMContentLoaded', () => {
    const header = document.getElementById('smart-header');
    if (header) new SmartHeader(header);
  });

  document.querySelectorAll('.smart-header').forEach(el => {
    new SmartHeader(el);
  });
})();